import React from 'react';
import SiteHeader from "../../../components/Template/SiteHeader";
import SignUpBanner from "../../../components/Banner/SignUpBanner";
import Footer from "../../../components/Template/Footer";
import Completed from "./Completed";

const CompletedWrapper: React.FC = () => {
  return (
      <div className="min-h-screen bg-white flex flex-col relative">
        <section className="bg-center bg-cover bg-no-repeat"
                 style={{backgroundImage: "url('/images/background-header.jpg')"}}>
          <SiteHeader/>
          <SignUpBanner/>
        </section>
        <section className="flex grow mt-8">
          <Completed/>
        </section>
        <Footer/>
      </div>
  );
};

export default CompletedWrapper;
